import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {InvoiceStateId} from '../../../../../api';

@Component({
  selector: 'elcia-invoice-state-dropdown',
  imports: [MultiDropdown],
  templateUrl: './invoice-state-dropdown.html',
})
export class InvoiceStateDropdown {
  private readonly translate = inject(TranslateService);

  control = input.required<FormControl>();

  private readonly lang = toSignal(this.translate.onLangChange, {initialValue: null});

  protected readonly items = computed(() => {
    this.lang();
    return Object.values(InvoiceStateId).map(state => ({
      id: state,
      name: this.translate.instant('invoice-state.' + state),
    }));
  });
}
